import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import React, { PropsWithChildren } from 'react';

import { IStripeElementsProviderProps } from './StripeElementsContext';
import config from '@config';
import { useColors } from '@hooks';

const stripe = loadStripe(config.STRIPE_KEY);

export function StripeElementsProvider({
  children,
  options = {},
  ...props
}: PropsWithChildren<IStripeElementsProviderProps>) {
  const colors = useColors();

  return (
    <Elements
      stripe={stripe}
      options={{
        ...options,
        appearance: {
          variables: {
            borderRadius: '12px',
            colorPrimary: colors.$primary400,
            colorText: colors.$heading800,
            colorDanger: colors.$error300,
          },
          rules: {
            // eslint-disable-next-line @typescript-eslint/naming-convention
            '.Input': {
              backgroundColor: colors.$background20,
              paddingLeft: '24px',
              paddingRight: '24px',
              paddingTop: '15px',
              paddingBottom: '15px',
              borderWidth: '1px',
            },
            // eslint-disable-next-line @typescript-eslint/naming-convention
            '.Input:focus': {
              borderWidth: '1px',
              borderColor: colors.$text400,
              boxShadow: 'none',
            },
            // eslint-disable-next-line @typescript-eslint/naming-convention
            '.Input--invalid': {
              borderWidth: '1px',
              borderColor: colors.$error300,
              boxShadow: 'none',
            },
            // eslint-disable-next-line @typescript-eslint/naming-convention
            '.Input::placeholder': {
              color: colors.$text60,
            },
          },
        },
      }}
      {...props}
    >
      {children}
    </Elements>
  );
}
